import { equals, pluck, uniq } from "ramda";

import theme from "styles/theme";
import { Category, IPosUser, IShift } from "types/schedules";

type CategoryColors = Category | "Unassigned";
type CategoryColorType = { [key in CategoryColors]: string };

const categoryColors: CategoryColorType = {
  "Front of House": theme.colors.dsGreenMedium,
  "Back of House": theme.colors.dsOrangeUpserve,
  Other: theme.colors.dsBluePrussian,
  Multiple: theme.colors.dsGrayMedium,
  Unassigned: theme.colors.dsGrayLight,
};

function getRoleLabel(assignee: IPosUser): string {
  const roleNames: string[] = pluck("name", assignee.roles);
  const uniqueRoleNames = uniq(roleNames);
  if (uniqueRoleNames.length > 1) {
    return "Multiple";
  }
  return uniqueRoleNames.length ? uniqueRoleNames[0] : "";
}

const ORDERED_CATEGORIES: Category[] = [
  "Front of House",
  "Back of House",
  "Other",
];

function getRoleCategoryPrecedence(assignee: IPosUser): number {
  const precedence = ORDERED_CATEGORIES.findIndex(catName => {
    return assignee.roles.some(role => role.category === catName);
  });
  return precedence !== -1 ? precedence : Infinity;
}

function getShiftRoleCategoryPrecedence(shift: IShift): number {
  const precedence = ORDERED_CATEGORIES.findIndex(equals(shift.role.category));
  return precedence !== -1 ? precedence : Infinity;
}

function getHighestRoleCategory(assignee: IPosUser): Category {
  const role = getRoleLabel(assignee);
  if (role === "Multiple") {
    return role;
  } else {
    return ORDERED_CATEGORIES[getRoleCategoryPrecedence(assignee)];
  }
}

export {
  categoryColors,
  CategoryColors,
  getHighestRoleCategory,
  getRoleCategoryPrecedence,
  getRoleLabel,
  getShiftRoleCategoryPrecedence,
  ORDERED_CATEGORIES,
};
